import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { EventInfoWithConsentResponse } from '@ent-regis/entregis-ts-angular';
import { FilterParams } from 'src/app/register-investor/models/register-investor.model';
import { FormGroup, FormControl } from '@angular/forms';

@Component({
  selector: 'app-investor-company-search-section',
  templateUrl: './investor-company-search-section.component.html',
  styleUrls: ['./investor-company-search-section.component.scss']
})
export class InvestorCompanySearchSectionComponent implements OnInit {

  @Input() eventInfoWithConsent!: EventInfoWithConsentResponse;
  @Input() sectorNames: string[] = [];
  @Output() filterChange = new EventEmitter<FilterParams>();
  
  selectedDateRangeText = '';
  
  dateRangeConfig = {
    dateInputFormat: 'MMM DD, YYYY',
    rangeInputFormat: 'MMM DD, YYYY',
    showWeekNumbers: false,
    containerClass: 'theme-orange',
  };
  
  filterForm!: FormGroup;

  ngOnInit() {
    const defaultExchange = this.eventInfoWithConsent && this.eventInfoWithConsent.isShowSalePersonForInvestorRegistration
      ? ['SET', 'OTHER']
      : ['SET'];

    this.filterForm = new FormGroup({
      exchange: new FormControl(defaultExchange),
      viewJumpplus: new FormControl(false),
      search: new FormControl(''),
      dateRange: new FormControl(null),
      sector: new FormControl(null),
      order: new FormControl('ASC'),
    });

    this.filterForm.valueChanges.subscribe(() => {
      this.onChange();
    });
  }

  onDateRangeChange(range: Date[]): void {
    this.filterForm.controls.dateRange.setValue(range, { emitEvent: false });
    this.selectedDateRangeText = this.formatDateRange(range);
    this.onChange();
  }

  clearDateRange(): void {
    this.filterForm.controls.dateRange.setValue(null, { emitEvent: false });
    this.selectedDateRangeText = '';
    this.onChange();
  }

  onChange() {
    const value = this.filterForm.value;
    const range = value.dateRange as Date[] | null;

    this.filterChange.emit({
      ...value,
      fromDate: range && range[0] ? range[0] : null,
      toDate: range && range[1] ? range[1] : null,
    });
  }

  private formatDateRange(range: Date[] | null): string {
    if (!range || !range[0]) {
      return '';
    }

    if (!range[1]) {
      return this.formatSingleDate(range[0]);
    }

    return this.formatRegisterPeriod(range[0], range[1]);
  }

  private formatSingleDate(date: Date): string {
    const monthFormatter = new Intl.DateTimeFormat('en-US', { month: 'short' });
    const month = monthFormatter.format(date);
    return `${month} ${date.getDate()}, ${date.getFullYear()}`;
  }

  private formatRegisterPeriod(start: Date, end: Date): string {
    const s = new Date(start);
    const e = new Date(end);

    const monthFormatter = new Intl.DateTimeFormat('en-US', { month: 'short' });

    const sm = monthFormatter.format(s);
    const em = monthFormatter.format(e);

    const sy = s.getFullYear();
    const ey = e.getFullYear();

    const sd = s.getDate();
    const ed = e.getDate();

    if (sm === em && sy === ey) {
      return `${sm} ${sd}-${ed}, ${sy}`;
    }

    if (sy === ey) {
      return `${sm} ${sd} - ${em} ${ed}, ${sy}`;
    }

    return `${sm} ${sd}, ${sy} - ${em} ${ed}, ${ey}`;
  }

  onExchangeChange(event: Event) {
    const checkbox = event.target as HTMLInputElement;
    const value = checkbox.value as 'SET' | 'OTHER';

    const current = (this.filterForm.value.exchange || []) as string[];

    if (checkbox.checked) {
      this.filterForm.patchValue({
        exchange: [...current, value]
      });
    } else {
      this.filterForm.patchValue({
        exchange: current.filter((v: string) => v !== value)
      });
    }
  }  

}
